import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import {
  alertsTableFilterControlSx,
  alertsTableFilterFieldClassName,
} from "./AlertsUtils/alertsFilterBar";

const OUTCOME_OPTIONS = [
  { name: "All", value: "All" },
  { name: "True Threat", value: "true_threat" },
  { name: "Escalated True Threat", value: "escalated_true_threat" },
  { name: "True Non-Threat", value: "true_non_threat" },
  { name: "False", value: "false_positive" },
];

export const OutcomeTypeFilter = ({
  outcomeFilterType,
  setOutcomeFilterType,
  setPage,
}: {
  outcomeFilterType: string;
  setOutcomeFilterType: Dispatcher<string>;
  setPage: Dispatcher<number>;
}) => {
  const selectedOption =
    OUTCOME_OPTIONS.find((option) => option.value === outcomeFilterType) ??
    OUTCOME_OPTIONS[0];

  return (
    <div className={`${alertsTableFilterFieldClassName} font-mulish`}>
      <Autocomplete
        disablePortal
        disableClearable
        options={OUTCOME_OPTIONS}
        getOptionLabel={(option) => option.name || ""}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        value={selectedOption}
        onChange={(_event, value) => {
          if (!value) {
            return;
          }
          setOutcomeFilterType(value.value);
          setPage(0);
        }}
        sx={alertsTableFilterControlSx}
        ListboxProps={{ sx: { fontFamily: "Mulish" } }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label="Outcome"
            autoComplete="off"
          />
        )}
        renderOption={(props, option) => (
          <li {...props} key={option.value}>
            {option.name}
          </li>
        )}
      />
    </div>
  );
};
